<template>
  <div>
    <div class="top-bar">
      <div class="left">
        <i class="icon el-icon-arrow-left" @click="switchYear(-1)"></i>
        <i class="icon el-icon-arrow-right" @click="switchYear(1)"></i>
        <span class="year">{{ year }}</span>
      </div>
      <div class="right" :class="{on: isTakeIn}" @click="isTakeIn = !isTakeIn">
        <div class="btn">{{ $t('crm.allEvents') }}</div>
        <div class="btn">{{ $t('crm.participated') }}</div>
      </div>
    </div>
    <div class="month-list">
      <div class="month" v-for="(item, index) in tableData2" :key="index">
        <div class="num">{{ item.month }}{{ $t('common.month') }}</div>
        <el-popover
          v-for="p in item.list" :key="p.salesPromotionId"
          placement="top-start"
          :title="$t('crm.promotionDesc')"
          width="500"
          trigger="click">
          <p>{{$t('crm.promotionName')}}：{{ p.promotionTitle }}</p>
          <p>{{$t('crm.promotionTime')}}：{{ p.activityStartTime }}~{{ p.activityEndTime }}</p>
          <p>{{$t('crm.whetherParticipate')}}：{{ p.isTakeIn ? $t('common.yes'):$t('common.no') }}</p>
          <div slot="reference" class="promotion" :class="{on: p.isTakeIn}">{{ p.promotionTitle }}</div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityListBy } from '../api';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      isTakeIn: false,
      tableData: [],
    };
  },
  computed: {
    tableData2() {
      return this.tableData.map(item => {
        return {
          ...item,
          list: this.isTakeIn ? item.list.filter(p => p.isTakeIn) : item.list,
        };
      });
    },
  },
  mounted() {
    this.getActivityListBy();
  },
  methods: {
    getActivityListBy() {
      getActivityListBy({
        year: this.year,
        vendorId: this.$route.params.id,
      }).then(res => {
        const monthList = []
        for (let i = 1; i <= 12; i++) {
          monthList.push({
            month: i,
            list: [],
          })
        }
        if (res.data && res.data.data) {
          res.data.data.forEach(item => {
            const m = this.getMonth(item.activityStartTime);
            monthList[m-1].list.push(item);
          });
        }
        this.tableData = monthList;
      })
    },
    getMonth(date) {
      return Number(date.substr(date.indexOf('-') + 1, 2));
    },
    switchYear(val) {
      if (this.year + val < 2017) {
        return;
      }
      if (this.year + val > new Date().getFullYear() + 2) {
        return;
      }
      this.year += val;
      this.getActivityListBy();
    },
  },
}
</script>

<style lang="less" scoped>
.top-bar {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;

    .icon {
      width: 20px;
      height: 30px;
      font-size: 16px;
      margin-right: 5px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;

      &:active {
        background-color: #ccc;
      }
    }
    .year {
      font-size: 18px;
    }
  }
  
  .right {
    display: flex;
    position: relative;
    padding: 5px;
    background-color: #f0f0f0;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;

    .btn {
      position: relative;
      width: 70px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      z-index: 1;
    }
    &::before {
      content: "";
      position: absolute;
      top: 5px;
      left: 5px;
      width: 70px;
      height: 20px;
      background-color: #fff;
      border-radius: 3px;
      transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    }
    &.on::before {
      transform: translateX(70px);
    }
  }
}

.month-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  border-right: 1px solid #E4E7ED;
  border-bottom: 1px solid #E4E7ED;

  .month {
    width: 50%;
    padding: 10px 5px;
    min-height: 100px;
    border-top: 1px solid #E4E7ED;
    border-left: 1px solid #E4E7ED;
  }
  .num {
    margin-left: 20px;
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: bold;
  }
  .promotion {
    position: relative;
    padding: 0 10px 0 20px;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background-color: darken(#fafafa, 10%);
    }
    &::before {
      content: "";
      position: absolute;
      top: 7px;
      left: 5px;
      width: 6px;
      height: 6px;
      background-color: #ccc;
      border-radius: 5px;
    }

    &.on::before {
      background-color: #409EFF;
    }
  }
}
</style>
